// Venues already attached to the competition must not be offered again in "Agregar club" (G5-3).
export const attachedVenueIds = (establishments = []) =>
  new Set((establishments || []).map((e) => String(e.tournament_venue_id ?? e.id)));

export const availableVenueOptions = (options = [], establishments = []) => {
  const attached = attachedVenueIds(establishments);
  return (options || []).filter((option) => !attached.has(String(option.id)));
};
